var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("van-divider", {
    style: { borderColor: "#BCBCBC", padding: "0 3%", margin: 0 },
    attrs: { dashed: _vm.dashed, hairline: _vm.hairline }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-685fccaf", esExports)
  }
}


// WEBPACK FOOTER //
// src/components-mall/divider/index.vue